class FlashDeals extends HTMLElement {
  connectedCallback() {
    this.countdowns = Array.from(this.querySelectorAll("[data-countdown]"));
    if (!this.countdowns.length) return;

    this.countdowns.forEach((el) => this.initCountdown(el));

    this.tick();
    this.timer = window.setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    if (this.timer) window.clearInterval(this.timer);
  }

  parseLocalEnd(value) {
    const match = String(value || "")
      .trim()
      .match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?$/);

    if (!match) return 0;

    const end = new Date(
      Number(match[1]),
      Number(match[2]) - 1,
      Number(match[3]),
      Number(match[4] || 23),
      Number(match[5] || 59),
      Number(match[6] || 0),
    );

    return Number.isNaN(end.getTime()) ? 0 : end.getTime();
  }

  initCountdown(el) {
    const localEnd = this.parseLocalEnd(el.dataset.endLocal);
    if (localEnd) el.dataset.end = String(localEnd);
  }

  hideOffer(el) {
    const wrapper = el.closest(".main_product_flash_deal_wrapper");
    if (wrapper) {
      wrapper.hidden = true;
      return;
    }

    const host = el.closest("flash-deals");
    if (host) host.hidden = true;
  }

  tick() {
    this.countdowns.forEach((el) => {
      if (el.dataset.ended === "true") return;

      const end = Number(el.dataset.end);
      const remaining = end - Date.now();
      const textEl = el.querySelector("[data-countdown-text]");
      if (!textEl) return;

      if (remaining > 0) {
        textEl.textContent = this.format(remaining);
        return;
      }

      el.dataset.ended = "true";

      if (el.dataset.endedAction === "hide") {
        this.hideOffer(el);
        return;
      }

      const endedText = el.dataset.endedText;
      if (endedText) textEl.textContent = endedText;
    });
  }

  // format(ms) {
  //   const totalSeconds = Math.max(Math.floor(ms / 1000), 0);
  //   const days = Math.floor(totalSeconds / 86400);
  //   const hours = Math.floor((totalSeconds % 86400) / 3600);
  //   const minutes = Math.floor((totalSeconds % 3600) / 60);
  //   const seconds = totalSeconds % 60;

  //   const parts = days > 0 ? [days, hours, minutes, seconds] : [hours, minutes, seconds];

  //   return parts.map((n) => String(n).padStart(2, "0")).join(" : ");
  // }

  format(ms) {
    const totalSeconds = Math.max(Math.floor(ms / 1000), 0);

    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (days > 0) {
      return `${String(days).padStart(2, "0")}d : ${String(hours).padStart(2, "0")}h : ${String(minutes).padStart(2, "0")}m : ${String(seconds).padStart(2, "0")}s`;
    }

    return `${String(hours).padStart(2, "0")}h : ${String(minutes).padStart(2, "0")}m : ${String(seconds).padStart(2, "0")}s`;
  }
    
}

if (!customElements.get("flash-deals")) {
  customElements.define("flash-deals", FlashDeals);
}
